import AlertsSection from '@/views/alerts/AlertsSection.vue';
import Alerts from '@/views/alerts/Alerts.vue';

export default [
  {
    path: '/alerts',
    component: AlertsSection,
    meta: {
      breadcrumb: {
        linkName: 'alerts.index',
        linkText: 'Alerts',
      },
    },
    children: [
      {
        path: 'explorer',
        component: Alerts,
        name: 'alerts.index',
      },
    ],
  },
];
